import { Component, computed, inject, Signal } from '@angular/core';
import { APP_CONFIG } from '@configuration/configuration';
import { Configuration } from '@models/interfaces/configuration/index.interface';
import { LogoComponent } from '@components/shared/logo/logo.component';
import { isInIframe } from '@helpers/utils/is-in-iframe.util';

@Component({
    selector: 'app-brand',
    imports: [LogoComponent],
    templateUrl: './brand.component.html',
    styleUrl: './brand.component.css'
})
export class BrandComponent {

    private readonly config: Signal<Configuration> = inject(APP_CONFIG);

    protected readonly clientName: Signal<string>  = computed(() => this.config().General.client.name ?? '');
    protected readonly venueName:  Signal<string>  = computed(() => this.config().General.texts.top ?? '');
    // Text color comes from the topbar mode (desktop: gradient colors, iframe: theme mode).
    protected readonly iframeMode: boolean         = isInIframe();

}
